// https://www.jqwidgets.com/angular-components-documentation/#toc-angular-ts-setup
import {AfterViewInit, Component, OnInit, ViewEncapsulation, OnChanges, SimpleChanges, NgZone, ChangeDetectorRef,
  ContentChild, ElementRef } from '@angular/core';
// import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
// import { jqxSchedulerComponent } from 'jqwidgets-ng/jqxscheduler';
import {onAuthUIStateChange, CognitoUserInterface, AuthState} from '@aws-amplify/ui-components';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
import Amplify, {Auth, Hub } from 'aws-amplify';
const AuthDebug = Auth;
// import awsconfig from '../aws-exports';
import {AuthService} from './auth/auth.service';
import {Router} from '@angular/router';
// Amplify.configure(awsconfig);
// Auth.configure(awsconfig);
// import * as $ from 'jquery';
import awsconfig from '../aws-exports';
import {CalendarDataService} from './service/calendar-data.service';
import * as DynamoDB from 'aws-sdk/clients/dynamodb';

declare const myTest: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements AfterViewInit, OnInit, OnChanges {
  federated = {
    facebook_app_id: '738745430399470',
    google_client_id: '738745430399470'
  };
  name =  'initial name';
  title = 'alc-angular-app';
  message = 'initial message';
  user: CognitoUserInterface | undefined;
  authState: AuthState;
  authenticator: any;
  authenticatorFormFields = [
    { type: 'username' ,
      label: '',
      inputProps: { required: true, autocomplete: 'username' , hidden: true}
    },
    { type: 'password' }/*,
    { type: 'email' }*/
  ];
  // tslint:disable-next-line:max-line-length
  // [Implement Authentication in Angular using AWS Amplify \-](https://www.unimedia.tech/2020/12/12/aws-amplify-authentication-with-angular/)
  formFields = [
    {
      type: 'username',
      label: 'Cloud queue username',
      placeholder: 'custom username placeholder',
      inputProps: { required: true, autocomplete: 'username' }
      // required: true,
    },
    {
      type: 'email',
      label: 'Cloud queue email',
      placeholder: 'custom email placeholder',
      required: true,
    },
    {
      type: 'password',
      label: 'Cloud queue Password',
      placeholder: 'custom password placeholder',
      required: true,
    },
    {
      type: 'custom:telegramid',
      label: 'telegram id',
      placeholder: 'telegram from 6 to 10 digits',
      required: true,
    },
  ];
  show(): void{ /*lastName: HTMLInputElement*/
    this.name = 'show name';
  }
  loginHosted(): void{
    // const config: FederatedSignInOptions = { provider: 'google'};
    // Auth.federatedSignIn(config);
    Auth.federatedSignIn(
      /*{provider: CognitoHostedUIIdentityProvider.Facebook}*/)
      .then(data => {
      console.log(data);
    }).catch(err => {
      console.log(err);
    });
  }

  signUpHosted(): void{
    // const config: FederatedSignInOptions = { provider: 'google'};
    // Auth.federatedSignIn(config);
    Auth.federatedSignIn(
      {provider: CognitoHostedUIIdentityProvider.Facebook,
      customState: 'signup'})
      .then(data => {
        console.log(data);
      }).catch(err => {
      console.log(err);
    });
  }
  // Query for a CONTENT child of type `ChildComponent`
  // @ContentChild(Auth) contentChild: Auth;
/*  logMessageId(el): void {
    const messageId = el.getAttribute('data-message-id');
    // let messageId = el.dataset.messageId;
    console.log('Message Id: ', messageId);
    this.authenticator = $('amplify-authenticator');
  }*/
  onClick(): any {
    myTest();
  }
  isAuthorized(): boolean{
    // ALC. It is weird but when I put this condition in *ngIf constract in the html template,
    // then bound variables inside childe componanets are not updated (ngOnChange is not called)
    return (this.authState === 'signedin' && this.user) ? true : false;
  }
  viewProfile(): void{
    this.router.navigate(['/profile']);
  }
/*  user: CognitoUserInterface | undefined;
  authState!: AuthState;

  constructor(private ref: ChangeDetectorRef) {
  }*/

  constructor(public calendarDataService: CalendarDataService,  public authService: AuthService,
              public router: Router, private zone: NgZone, private ref: ChangeDetectorRef) {
    // tslint:disable-next-line:max-line-length
    // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
    // authService.setIdToken();
    Hub.listen('auth', (data) => {
          console.log('Listening for all messages: ', data.payload ? data.payload.data ?? '' : '');
          this.onAuthEvent(data.payload);
        });
    // this.service.connect();
  }
  ngOnChanges(changes: SimpleChanges): void {
    // changes.prop contains the old and the new value...
    console.log(changes);
  }
  ngAfterViewInit(): void {
    /*this.scheduler.ensureAppointmentVisible('id1');*/
/*    Auth.currentCredentials().then(data => {
      console.log(data);
    });*/
    // this.authenticator = $('amplify-authenticator');
    console.log('ngAfterViewInit');
/*    if (!this.authState){
      Auth.federatedSignIn()
        .then(data => {
        console.log(data);
      }).catch(err => {
        console.log(err);
      });
    }*/
  }
  getWidth(): any {
    if (document.body.offsetWidth < 850) {
      return '90%';
    }
    return 850;
  }
  onAuthEvent(payload): void {
    // ... your implementation
    /*if (payload && payload.event && (
      (payload.event === 'AuthStateChange' && payload.message && payload.message === 'signedout')
      || (payload.event === 'SignOut' && payload.message && payload.message === 'A user has been signed out'))
    )*/
    // tslint:disable-next-line:max-line-length
    // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
    /*    if (!this.authService.isLoggedIn){
          // Redirect the user
          const redirectUrl = '/login';
          this.zone.run(() => this.router.navigate([redirectUrl]));
        } else
        /!*if (payload && payload.event && payload.event === 'AuthStateChange' && payload.message && payload.message === 'signedin')*!/
        {
          console.log(payload.message);
          // Usually you would use the redirect URL from the auth service.
          // However to keep the example simple, we will always redirect to `/admin`.
          const redirectUrl = this.authService.redirectUrl ?? '/home';
          // Redirect the user
          this.zone.run(() => this.router.navigate([redirectUrl]));
        }*/
  }
  ngOnInit(): void {
    // tslint:disable-next-line:max-line-length
    // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
/*    Auth.currentCredentials().then(response => {
      console.log(response);
      if (response && response.authenticated){
        this.authService.loggedIn();
        // Redirect the user
        const redirectUrl = this.authService.redirectUrl ?? '/home';
        this.zone.run(() => this.router.navigate([redirectUrl]));
      } else {
        console.log('loggedOut');
        // Redirect the user
        const redirectUrl = this.authService.redirectUrl ?? '/login';
        this.zone.run(() => this.router.navigate([redirectUrl]));
      }
    });*/
/*    const username = 'username';
    const password = 'username';
    const tg = 'tg';
    Auth.signUp({
      username,
      password,
      attributes: {
        tg,
        'custom:telegram': 'Cookie Dough'  // custom attribute, not standard
      }
    }).then(data => {
      console.log(data);
    }).catch(err => {
      console.log(err);
    });*/
    // tslint:disable-next-line:max-line-length
    // Standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
    onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData as CognitoUserInterface;
      this.authService.authState = authState;
      this.authService.user = authData as CognitoUserInterface;
      this.authService.userSubject$.next(this.authService.user);
/*      this.authService.setIdToken()
        .then(() => {
          console.log(`app.component.ts => onAuthUIStateChange => authService.setIdToken`);
          const authCredentialsSubjectObserver = {
            next: (data) => {
              this.authService.identityAuthorized = true;
              this.calendarDataService.identityAuthorized = true;
              console.log(`app.component.ts => onAuthUIStateChange => authService.setIdToken`);
            },
            error: (err) => {
              console.log(err);
            }
          };
          this.authService.authCredentialsSubject$.subscribe(authCredentialsSubjectObserver);
        })
        .catch((err) => {
          console.log(err);
        });*/
      this.authService.getCognitoCredentials()
        .then(() => {
              this.calendarDataService.identityAuthorized = true;
              this.calendarDataService.docClient = new DynamoDB.DocumentClient();
              console.log(`app.component.ts => onAuthUIStateChange => authService.getCognitoCredential`);
        })
        .catch((err) => {
          console.log(`app.component.ts => err = ${err}`);
        });
      this.ref.detectChanges();
    });
  }
}
